import React, { useState, useEffect } from 'react';
// Component moved from root console directory to system-management subdirectory
const UserManual: React.FC = () => {
  return <div>User Manual - Component moved to system-management directory</div>;
};

export default UserManual;
